var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteInactiveBlueIcon = function SvgDeleteInactiveBlueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    d: "m15.24 9-.346 9m-4.788 0L9.76 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.66 19.673a2.25 2.25 0 0 1-2.244 2.077H8.584a2.25 2.25 0 0 1-2.244-2.077L5.272 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.088 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0"
  })));
};
export { SvgDeleteInactiveBlueIcon as ReactComponent };
export default __webpack_public_path__ + "aeedaaab71ce99d5ed66a7e94db527e2.svg";